import React from "react";
import { Link } from "react-router-dom";
import { AboutData } from "../../data";

export default function AboutPageWrapper() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [intro, ...rest] = AboutData;
  return (
    <div>
      <section className="bg-gradient-to-b from-secondary-light to-white">
        <div className="mx-auto w-[92%] max-w-[900px] space-y-5 py-20 text-center lg:py-28">
          <span className="inline-flex rounded-full bg-secondary-dark/15 px-3.5 py-1 text-[13px] font-semibold text-[#9a6f08]">
            About us
          </span>
          <h1 className="text-4xl font-extrabold tracking-tight text-primary-dark lg:text-6xl">
            {intro?.title || "Powering transparency in energy"}
          </h1>
          <p className="mx-auto max-w-[680px] text-lg leading-relaxed text-[#5b5f73]">{intro?.paragraph}</p>
        </div>
      </section>

      <section className="mx-auto w-[92%] max-w-[1000px] space-y-14 py-20">
        {rest.map((item, i) => (
          <article key={i} className="space-y-6">
            {item.title && <h2 className="text-2xl font-bold text-primary-dark">{item.title}</h2>}
            {item.paragraph && <p className="text-lg leading-relaxed text-[#5b5f73]">{item.paragraph}</p>}
            {(item.content || []).flatMap((group) =>
              Object.entries(group).map(([head, body]) => (
                <div key={head} className="rounded-2xl border border-black/5 bg-[#FAFAFD] p-6">
                  <h3 className="mb-1 font-semibold text-primary-dark">{head.replace(/:$/, "")}</h3>
                  <p className="leading-relaxed text-[#5b5f73]">{body}</p>
                </div>
              ))
            )}
          </article>
        ))}
        <div className="text-center">
          <Link to="/contact" className="inline-flex rounded-full bg-primary-dark px-7 py-3.5 font-semibold text-white hover:bg-primary-light">
            Talk to us
          </Link>
        </div>
      </section>
    </div>
  );
}
